import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';

const getUser = (state: IGlobalReduxStore) => state.auth.user;

export const isUserPendingApprovalSelector = createSelector(getUser, (user) => {
  if (!user) return false;
  return user.access_status === 'not_approved';
});
